// ===================================================================
// KAIXO - Cliente API del sistema de soporte
// ===================================================================

import api from './api';

export const supportListFaqs = (lang) =>
    api.get('/support/faqs', { params: lang ? { lang } : {} });

export const supportMarkHelpful = (key) =>
    api.post(`/support/faqs/${encodeURIComponent(key)}/helpful`);

export const supportMarkEscalated = (key) =>
    api.post(`/support/faqs/${encodeURIComponent(key)}/escalated`);

export const supportAsk = (message) =>
    api.post('/support/ask', { message });

export const supportCreateTicket = (message, category = 'general') =>
    api.post('/support/tickets', { message, category });

export const supportMyTickets = () => api.get('/support/tickets/mine');
export const supportGetConversation = () => api.get('/support/conversation');

// ── Admin ─────────────────────────────────────────────────────────
export const adminSupportListTickets = (status) =>
    api.get('/support/admin/tickets', { params: status ? { status } : {} });

export const adminSupportGetTicket = (id) =>
    api.get(`/support/admin/tickets/${id}`);

export const adminSupportReply = (id, text) =>
    api.post(`/support/admin/tickets/${id}/reply`, { text });

export const adminSupportCloseTicket = (id) =>
    api.post(`/support/admin/tickets/${id}/close`);

export const adminSupportResetPassword = (id) =>
    api.post(`/support/admin/tickets/${id}/reset-password`);

export const adminSupportUpdateTicket = (id, data) =>
    api.put(`/support/admin/tickets/${id}`, data);

export const adminSupportListFaqs = () => api.get('/support/admin/faqs');
export const adminSupportCreateFaq = (data) => api.post('/support/admin/faqs', data);
export const adminSupportUpdateFaq = (id, data) => api.put(`/support/admin/faqs/${id}`, data);
export const adminSupportDeleteFaq = (id) => api.delete(`/support/admin/faqs/${id}`);
